// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__xk5yh","title":"Info_title__XkdUs","selects":"Info_selects__3qlV8","requiredAsterisk":"Info_requiredAsterisk__1o3bP"};